export default {
  translation: {
    nav: {
      home: 'Accueil',
      trips: 'Voyages',
      aboutUs: 'À propos',
      uganda: 'Ouganda',
      wishlist: 'Favoris',
      language: 'Langue',
      profile: 'Profil',
      settings: 'Paramètres',
      signIn: 'Connexion',
      signUp: 'Inscription',
      mainMenu: 'Menu Principal',
      account: 'Compte',
      blog: 'Blog',
      adventures: 'Aventures'
    },
    adventures: {
      all: 'Toutes les Aventures',
      safariPackages: 'Forfaits Safari',
      cityTours: 'Visites de Ville',
      culturalTours: 'Visites Culturelles',
      selfDrive: 'Auto-Guidé',
      allExperiences: 'Toutes les Expériences',
      gorillaTrekking: 'Trekking des Gorilles',
      chimpanzeeTracking: 'Observation des Chimpanzés',
      customizeSafari: 'Personnaliser Votre Safari',
      nightlifeGuide: 'Guide de Vie Nocturne'
    },
    hero: {
      title: 'Explorez l\'Ouganda',
      subtitle: 'et au-delà',
      description: 'Découvrez la Perle de l\'Afrique avec des guides locaux experts. Des expériences inoubliables vous attendent dans les paysages à couper le souffle et la culture vibrante de l\'Ouganda.',
      searchPlaceholder: 'Où allez-vous ?',
      categories: {
        all: 'Tout',
        wildlife: 'Faune',
        safari: 'Safari',
        cultural: 'Culturel',
        adventure: 'Aventure',
        birding: 'Ornithologie'
      },
      stats: {
        experiences: 'Expériences',
        guides: 'Guides Locaux',
        travelers: 'Voyageurs Satisfaits',
        rating: 'Note Moyenne'
      }
    },
    experiences: {
      title: 'Meilleures Expériences en Ouganda',
      subtitle: 'Réserver ces expériences populaires à l\'avance garantit votre place',
      categories: {
        all: 'Toutes les catégories',
        wildlife: 'Faune',
        safari: 'Safari',
        cultural: 'Culturel',
        adventure: 'Aventure',
        birding: 'Observation d\'oiseaux'
      },
      viewDetails: 'Voir les détails'
    },
    cityTours: {
      title: 'Visites de Villes',
      subtitle: 'Découvrez les villes vibrantes de l\'Ouganda et leurs attractions uniques'
    },
    giveaway: {
      title: 'Gagnez un Safari Gratuit en Ouganda !',
      subtitle: 'Offre à Durée Limitée',
      description: 'Nous offrons à 19 voyageurs chanceux l\'opportunité ultime de découvrir la magie de l\'Ouganda GRATUITEMENT !',
      enterButton: 'Je Tente Ma Chance',
      whatsIncluded: 'Ce Qui Est Inclus :',
      howItWorks: 'Comment Ça Marche :',
      eligibility: 'Éligibilité :',
      viewTerms: 'Voir les conditions générales',
      winners: 'gagnants à sélectionner',
      nextWinner: 'Prochain Tirage Dans :',
      days: 'Jours',
      hours: 'Heures',
      minutes: 'Minutes',
      seconds: 'Secondes',
      enterGiveaway: 'Participer au Tirage',
      yourEmail: 'Votre Adresse Email',
      enterEmail: 'Entrez votre email pour participer',
      entryReceived: 'Participation Enregistrée !',
      thankYou: 'Merci pour votre participation ! Vérifiez votre email pour la confirmation et restez à l\'écoute pour l\'annonce du gagnant.',
      pastWinners: 'Expériences des Anciens Gagnants'
    },
    becomeGuide: {
      title: 'Devenez Guide TravelCord',
      subtitle: 'Partagez la Beauté de l\'Ouganda !',
      description: 'Transformez votre passion pour l\'Ouganda en une carrière enrichissante. Rejoignez notre communauté de guides locaux experts.',
      benefits: {
        earnings: 'Gagnez Plus',
        earningsDesc: 'Conservez jusqu\'à 85% des frais de réservation',
        reach: 'Portée Mondiale',
        reachDesc: 'Connectez-vous avec des voyageurs du monde entier',
        share: 'Partagez des Joyaux',
        shareDesc: 'Présentez des expériences locales',
        flexible: 'Flexible',
        flexibleDesc: 'Travaillez selon votre emploi du temps'
      },
      stats: {
        guides: 'Guides Actifs',
        travelers: 'Voyageurs Satisfaits',
        rating: 'Note Moyenne',
        commission: 'Taux de Commission'
      },
      features: {
        profile: 'Profil professionnel et système de réservation',
        payments: 'Traitement sécurisé des paiements',
        marketing: 'Support marketing et promotionnel',
        support: 'Support client 24/7'
      },
      applyNow: 'Postuler Maintenant'
    },
    howItWorks: {
      title: 'Pourquoi Réserver avec TravelCord',
      subtitle: 'Connecter les voyageurs avec des expériences authentiques et des guides locaux en Ouganda',
      features: {
        verifiedGuides: {
          title: 'Guides Locaux Vérifiés',
          description: 'Tous nos guides sont soigneusement sélectionnés et possèdent une connaissance approfondie du terrain.'
        },
        bestPrice: {
          title: 'Garantie Meilleur Prix',
          description: 'Trouvez moins cher ? Nous égalisons le prix et vous offrons 10% de réduction sur votre prochaine réservation.'
        },
        flexibleBooking: {
          title: 'Réservation Flexible',
          description: 'Annulation gratuite jusqu\'à 24 heures avant votre expérience. Sans questions.'
        },
        localExpertise: {
          title: 'Expertise Locale',
          description: 'Découvrez des informations authentiques et des joyaux cachés grâce aux guides qui connaissent l\'Ouganda le mieux.'
        }
      },
      bookingProcess: {
        title: 'Processus de Réservation Simple',
        steps: {
          browse: 'Parcourez les expériences et sélectionnez votre date préférée',
          choose: 'Choisissez la taille de votre groupe et vos exigences spéciales',
          secure: 'Sécurisez votre réservation avec notre système de paiement facile'
        }
      },
      qualityAssurance: {
        title: 'Assurance Qualité',
        licensed: 'Guides licenciés et assurés',
        quality: 'Contrôles de qualité réguliers',
        groups: 'Petits groupes pour une meilleure expérience'
      },
      support: {
        title: 'Support Client',
        assistance: 'Assistance client 24/7',
        payment: 'Protection de paiement sécurisée',
        satisfaction: 'Satisfaction garantie'
      }
    },
    footer: {
      explore: {
        title: 'Explorer',
        description: 'Embarquez pour un voyage extraordinaire à travers la nature sauvage de l\'Ouganda, où les gorilles des montagnes parcourent les forêts anciennes, les lions grimpent aux arbres dans de vastes savanes, et des cultures vibrantes vous accueillent à bras ouverts.',
        findGuides: 'Trouver des Guides',
        safariAdventures: 'Aventures Safari',
        culturalExperiences: 'Expériences Culturelles',
        wildlifeTours: 'Tours Animaliers',
        cityExplorations: 'Explorations Urbaines'
      },
      about: {
        title: 'À propos',
        aboutUs: 'À propos de nous',
        becomeGuide: 'Devenir Guide',
        partnership: 'Partenariat',
        careers: 'Carrières',
        press: 'Espace Presse'
      },
      contact: {
        title: 'Contact',
        address: 'Ntinda, Kampala, Ouganda',
        phone: '+256766830194',
        email: 'info@travelcord.guide'
      },
      legal: {
        copyright: '© 2025 TravelCord. Tous droits réservés.',
        privacy: 'Politique de Confidentialité',
        terms: 'Conditions d\'Utilisation',
        cookies: 'Politique des Cookies',
        sitemap: 'Plan du Site'
      }
    },
    common: {
      loading: 'Chargement...',
      error: 'Une erreur est survenue',
      retry: 'Réessayer',
      viewMore: 'Voir plus',
      viewLess: 'Voir moins',
      search: 'Rechercher',
      select: 'Sélectionner',
      cancel: 'Annuler',
      submit: 'Envoyer',
      save: 'Sauvegarder',
      edit: 'Modifier',
      delete: 'Supprimer',
      confirm: 'Confirmer',
      back: 'Retour',
      next: 'Suivant',
      finish: 'Terminer',
      close: 'Fermer',
      required: 'Requis',
      optional: 'Optionnel',
      from: 'à partir de',
      reviews: 'avis',
      book: 'Réserver',
      seeAll: 'Voir tout',
      for: 'pour',
      years: 'ans'
    },
    forms: {
      booking: {
        title: 'Réserver cette Expérience',
        personalInfo: 'Informations Personnelles',
        tourDetails: 'Détails du Tour',
        payment: 'Détails du Paiement',
        firstName: 'Prénom',
        lastName: 'Nom',
        email: 'Adresse Email',
        phone: 'Numéro de Téléphone',
        date: 'Date',
        travelers: 'Voyageurs',
        specialRequests: 'Demandes Spéciales',
        total: 'Total',
        submit: 'Finaliser la Réservation'
      },
      quote: {
        title: 'Demander un Devis',
        name: 'Nom',
        email: 'Email',
        phone: 'Téléphone',
        message: 'Message',
        submit: 'Envoyer la Demande'
      }
    },
    success: {
      title: 'Soumission Réussie !',
      message: 'Merci pour votre soumission. Nous avons reçu votre demande et vous recontacterons bientôt.',
      returnHome: 'Retour à l\'Accueil'
    },
    pages: {
      aboutUs: {
        title: 'À Propos de Nous',
        subtitle: 'Connecter les Voyageurs avec l\'Expertise Locale',
        description: 'Découvrez notre histoire, notre mission et notre équipe dévouée.',
        ourStory: 'Notre Histoire',
        ourValues: 'Nos Valeurs',
        contactUs: 'Contactez-Nous'
      },
      allExperiences: {
        title: 'Toutes les Expériences en Ouganda',
        subtitle: 'Découvrez notre collection complète d\'expériences authentiques ougandaises',
        filters: 'Filtres',
        sortBy: 'Trier par',
        noResults: 'Aucune expérience trouvée',
        resetFilters: 'Réinitialiser les filtres'
      },
      blog: {
        title: 'Blog Safari & Voyage en Ouganda',
        subtitle: 'Guides d\'experts, conseils et histoires sur le trekking des gorilles, les safaris et les expériences culturelles',
        searchPlaceholder: 'Rechercher des guides safari, trekking de gorilles...',
        featuredStories: 'Histoires à la Une',
        categories: 'Catégories',
        popularTopics: 'Sujets Populaires',
        newsletterTitle: 'Mises à Jour Safari',
        writeForUs: 'Écrire pour Nous'
      },
      careers: {
        title: 'Rejoignez Notre Équipe',
        subtitle: 'Aidez-nous à présenter la beauté de l\'Ouganda au monde',
        benefits: 'Avantages',
        openPositions: 'Postes Ouverts',
        applicationForm: 'Formulaire de Candidature'
      },
      cityTours: {
        title: 'Visites de Villes en Ouganda',
        subtitle: 'Découvrez les villes vibrantes de l\'Ouganda avec nos guides locaux',
        kampala: 'Visites de Kampala',
        jinja: 'Visites de Jinja',
        entebbe: 'Visites d\'Entebbe',
        bookNow: 'Réserver Maintenant'
      },
      customizeAdventure: {
        title: 'Personnalisez Votre Aventure',
        subtitle: 'Créez votre expérience ougandaise parfaite',
        chooseGuide: 'Choisissez Votre Guide',
        customizeExperience: 'Personnalisez Votre Expérience',
        finalDetails: 'Détails Finaux',
        requestQuote: 'Demander un Devis'
      },
      gorillaTrekking: {
        title: 'Trekking des Gorilles en Ouganda',
        subtitle: 'Rencontrez les gorilles de montagne dans leur habitat naturel',
        essentialInfo: 'Informations Essentielles',
        bestTime: 'Meilleure Période',
        requirements: 'Exigences',
        whatToBring: 'Que Faut-il Apporter'
      },
      guideProfile: {
        title: 'Profil du Guide',
        experience: 'Expérience',
        languages: 'Langues',
        specialties: 'Spécialités',
        reviews: 'Avis',
        tours: 'Tours Complétés',
        bookNow: 'Réserver Maintenant',
        contactGuide: 'Contacter le Guide',
        aboutGuide: 'À Propos du Guide',
        certifications: 'Certifications',
        achievements: 'Réalisations'
      },
      nightlife: {
        title: 'Guide de la Vie Nocturne en Ouganda',
        subtitle: 'Votre guide ultime pour explorer la scène nocturne vibrante de l\'Ouganda',
        packages: 'Forfaits Tout Compris',
        clubs: 'Clubs & Bars',
        streetFood: 'Circuit de Street Food',
        safety: 'Sécurité & Étiquette',
        bookNow: 'Réserver Maintenant',
        essentials: 'Essentiels pour la Vie Nocturne',
        bestNights: 'Meilleures Soirées',
        peakHours: 'Heures de Pointe',
        startingPoint: 'Point de Départ',
        dressCode: 'Code Vestimentaire',
        whatsIncluded: 'Ce qui est inclus dans votre forfait',
        vipEntry: 'Entrée VIP en Club',
        vipEntryDesc: 'Évitez les files d\'attente avec un accès VIP à tous les clubs et lieux. Pas de frais de couverture ou d\'entrée - tout est inclus !',
        foodDrinks: 'Nourriture & Boissons',
        foodDrinksDesc: 'Profitez de dégustations gratuites de street food et de boissons de bienvenue à chaque endroit. Options de boissons supplémentaires disponibles.',
        safetyGuidance: 'Sécurité & Orientation',
        safetyGuidanceDesc: 'Des guides professionnels et du personnel de sécurité assurent votre sécurité tout au long de la nuit tout en vous montrant les meilleurs endroits.',
        whyBookWithUs: 'Pourquoi Réserver Avec Nous',
        photoPackage: 'Forfait Photo en Option',
        photoPackageDesc: 'Capturez votre soirée avec notre option de photographie professionnelle. Un photographe dédié rejoindra votre groupe pour documenter votre expérience.',
        groupBooking: 'Avantages des Réservations de Groupe',
        groupBookingDesc: 'Vous réservez en groupe ? Profitez d\'avantages spéciaux et de réductions lorsque vous réservez pour 4 personnes ou plus !',
        contactGroup: 'Contact pour les Réservations de Groupe',
        contactGroupDesc: 'Pour les groupes de 4 personnes ou plus, contactez notre équipe pour des arrangements spéciaux et des réductions.',
        streetFoodCircuit: 'Circuit de Street Food',
        nightMarkets: 'Marchés Nocturnes & Bazars',
        nightclubScene: 'Scène des Boîtes de Nuit',
        tierSystem: 'Système à 3 Niveaux Célèbre de l\'Ouganda',
        platinumTier: 'Clubs de Niveau Platine',
        goldTier: 'Clubs de Niveau Or',
        undergroundScene: 'Scène Underground',
        safetyEtiquette: 'Sécurité & Étiquette',
        safetyPriority: 'Votre Sécurité est Notre Priorité',
        clubEntryTips: 'Conseils pour l\'Entrée en Club',
        transport: 'Transport',
        proTips: 'Conseils de Pros de Nos Guides',
        weeklyHighlights: 'Temps Forts Hebdomadaires',
        faq: 'Questions Fréquemment Posées',
        readyToExperience: 'Prêt à Découvrir la Vie Nocturne de l\'Ouganda ?',
        readyToExperienceDesc: 'Réservez votre forfait de vie nocturne tout compris aujourd\'hui et laissez-nous tout gérer pendant que vous profitez d\'une soirée inoubliable !',
        viewPackages: 'Voir les Forfaits',
        contactUs: 'Contactez-Nous',
        lastUpdated: 'Dernière mise à jour',
        contributor: 'Contributeur',
        reportChanges: 'Signaler des changements'
      },
      partnership: {
        title: 'Partenariat avec TravelCord',
        subtitle: 'Rejoignez la principale plateforme de tourisme de l\'Ouganda',
        opportunities: 'Opportunités de Partenariat',
        benefits: 'Avantages',
        application: 'Demande de Partenariat',
        testimonials: 'Témoignages'
      },
      resources: {
        title: 'Ressources de Voyage en Ouganda',
        subtitle: 'Guides téléchargeables, cartes et listes de contrôle',
        categories: 'Catégories de Ressources',
        download: 'Télécharger le Guide Gratuit',
        testimonials: 'Ce que disent les voyageurs'
      },
      safariPackages: {
        title: 'Forfaits Safari',
        subtitle: 'Découvrez nos forfaits safari soigneusement sélectionnés',
        filters: 'Filtres',
        priceRange: 'Fourchette de Prix',
        duration: 'Durée',
        viewDetails: 'Voir les Détails',
        bookNow: 'Réserver Maintenant'
      },
      selfDriveSafaris: {
        title: 'Safaris Auto-Guidés en Ouganda',
        subtitle: 'Explorez l\'Ouganda à votre propre rythme',
        chooseVehicle: 'Choisissez Votre Véhicule',
        customizeExperience: 'Personnalisez Votre Expérience',
        requirements: 'Exigences',
        roadConditions: 'Conditions Routières',
        safetyGuidelines: 'Consignes de Sécurité'
      },
      travelGuides: {
        title: 'Guides Locaux Experts en Ouganda',
        subtitle: 'Connectez-vous avec nos guides locaux expérimentés',
        filters: 'Filtres',
        sortBy: 'Trier par',
        specialties: 'Spécialités',
        languages: 'Langues',
        viewProfile: 'Voir le Profil'
      },
      uganda: {
        title: 'Bienvenue en Ouganda',
        subtitle: 'Découvrez la Perle de l\'Afrique',
        nationalParks: 'Parcs Nationaux',
        popularActivities: 'Activités Populaires',
        bestTimeToVisit: 'Meilleure Période pour Visiter',
        travelTips: 'Conseils de Voyage'
      },
      writeForUs: {
        title: 'Écrire pour TravelCord',
        subtitle: 'Partagez vos expériences de voyage en Ouganda',
        guidelines: 'Directives de Soumission',
        whatWeLookFor: 'Ce que Nous Recherchons',
        requirements: 'Exigences des Articles',
        benefits: 'Avantages',
        submitPitch: 'Soumettre une Proposition'
      }
    }
  }
};